/* eslint-disable react/no-danger */
import React, { useState } from "react";
import { string, object, bool } from "prop-types";
import classNames from "classnames/bind";
import merge from "lodash.mergewith";
import * as sharedStyles from "./ContentTextSection.module.scss";

let cx = classNames.bind(sharedStyles);

const ContentTextSection = ({ text, collapse, styles }) => {
	const [iscollapsed, setIsCollapsed] = useState(true);

	let stateClasses = "";
	let buttonText = "";

	if (iscollapsed === true) {
		stateClasses = cx(
			"textSection",
			"textSectionCustom",
			"collapseSection",
			"collapseSectionCustom"
		);
		buttonText = "Read More";
	} else {
		stateClasses = cx("textSection", "textSectionCustom");
		buttonText = "Show Less";
	}

	cx = classNames.bind(merge(sharedStyles, styles));
	return (
		<div className={cx("textSectionWrapper", "textSectionWrapperCustom")}>
			<div
				className={collapse ? stateClasses : cx("textSection", "noAnimation", "textSectionCustom")}
				dangerouslySetInnerHTML={{
					__html: text,
				}}
			/>

			{collapse && (
				<button
					className={cx("collapseButton", "collapseButtonCustom", "buttonClean")}
					type="button"
					onClick={() => setIsCollapsed(!iscollapsed)}>
					{buttonText}
				</button>
			)}
		</div>
	);
};

ContentTextSection.propTypes = {
	text: string,
	collapse: bool,
	styles: object,
};
ContentTextSection.defaultProps = {
	text: null,
	collapse: false,
	styles: null,
};

export default ContentTextSection;
export { ContentTextSection };
